import {api} from '../api/loginRoutes'
import {createAction} from './defaults'
import {
    CDR_GET_LIST_SUCCESS,
    CDR_SET_LOADING,

    MDR_FAILED_GET_LIST_SUCCESS,
    MDR_FAILED_SET_LOADING
} from "./actionTypes";
import {CDR_LIST_METHOD, CDR_LIST_SMS_METHOD, MDR_FAILED_LIST_METHOD} from "../const/apiMethods";
import {CDR_PER_PAGE, MDR_FAILED_PER_PAGE} from "../const/localStorageKeys";
import {DEFAULT_PER_PAGE_BIG} from "../const";
import {DESC_SORT} from "const";
import {getISOTime, toUTCDateTime, removeTZFromDate, toStartDayTime, toEndDayTime} from "utils";

const setLoading = createAction(CDR_SET_LOADING);
const setCDRList = createAction(CDR_GET_LIST_SUCCESS);

const setFailedMdrLoading = createAction(MDR_FAILED_SET_LOADING);
const setFailedMDRList = createAction(MDR_FAILED_GET_LIST_SUCCESS);

export const getCDRList = (service = true, filter = {}, page = 1, per_page = DEFAULT_PER_PAGE_BIG, sort = {}) => (dispatch) => {
    dispatch(setLoading(true));

    const sort1 = sort.column;
    const sort1_desc = sort.type && sort.type === DESC_SORT;

    const currentFilter = {...filter};

    if (currentFilter.range && currentFilter.range.length) {
        // currentFilter['start_date'] = toStartDayUTCTime(currentFilter.range[0]);
        // currentFilter['end_date'] = toEndDayUTCTime(currentFilter.range[1]);
        // currentFilter['start_date'] = toUTCDateTime(currentFilter.range[0]);
        // currentFilter['end_date'] = toUTCDateTime(currentFilter.range[1]);
        currentFilter['start_date'] = toUTCDateTime(currentFilter.range[0]);
        currentFilter['end_date'] = toUTCDateTime(currentFilter.range[1]);

        delete currentFilter.range;
    }
    const method = service ? CDR_LIST_METHOD : CDR_LIST_SMS_METHOD;

    api(method, {filter: currentFilter, page, per_page, sort1, sort1_desc})
        .then((result) => {
            localStorage.setItem(CDR_PER_PAGE, per_page);

            dispatch(setCDRList({
                list: result?.cdr_full_list || result['sms.mdr_full_list'],
                more: result?.cdr_full_more || result['sms.mdr_full_more'],
                count: result?.cdr_full_count || result['sms.mdr_full_count'],
                perPage: per_page,
                page: page
            }));
        })
        .catch((error) => {
            dispatch(setLoading(false));
        })
};

export const getFailedMDRList = (filter = {}, page = 1, per_page = DEFAULT_PER_PAGE_BIG, sort = {}) => (dispatch) => {
    dispatch(setFailedMdrLoading(true));

    const sort1 = sort.column;
    const sort1_desc = sort.type && sort.type === DESC_SORT;

    const currentFilter = {...filter};

    if (currentFilter.range && currentFilter.range.length) {
        currentFilter['start_date'] = toUTCDateTime(currentFilter.range[0]);
        currentFilter['end_date'] = toUTCDateTime(currentFilter.range[1]);

        delete currentFilter.range;
    }
    const method = MDR_FAILED_LIST_METHOD;

    api(method, {filter: currentFilter, page, per_page, sort1, sort1_desc})
        .then((result) => {
            localStorage.setItem(MDR_FAILED_PER_PAGE, per_page);

            dispatch(setFailedMDRList({
                list: result['sms.mdr_short_list'],
                more: result['sms.mdr_short_more'],
                count: result['sms.mdr_short_count'],
                perPage: per_page,
                page: page
            }));
        })
        .catch((error) => {
            dispatch(setFailedMdrLoading(false));
        })
};